import { tabChange } from './modules/tabChange';

tabChange();
parkForm();

function parkForm() {
  var dispIAdress = function () {
    if ($('input[name="i_address"]').is(':checked')) {
      $('.js-checkAddressCont').show();
    } else {
      $('.js-checkAddressCont').hide();
      $('input[name="i_name"], input[name="i_zip"], input[name="i_pref"], input[name="i_tel"], input[name="i_fax"]').val('');
    }
  };

  var dispMAdress = function () {
    if ($('input[name="m_address"]').is(':checked')) {
      $('.js-mAddress').show();
    } else {
      $('.js-mAddress').hide();
      $('input[name="m_zip"], input[name="m_pref"]').val('');
    }
  };

  var dispInvocieType = function (v) {
    if ($('input[name="invoice_type[]"][value="etc"]').is(':checked')) {
      $('.js-invoiceContent').show();
    } else {
      $('.js-invoiceContent').hide();
      $('input[name="etc_name"], input[name="etc_tel"], input[name="etc_zip"], input[name="etc_pref"]').val('');
    }
  };

  $(document).ready(function () {
    // datepicker
    $('.js-datePicker').datepicker({ dateFormat: 'yy/mm/dd' }),
      $(document).on('click', '.js-datePickerIco', function (e) {
        var t = $(this).data('rel');
        $('input[name="' + t + '"]').datepicker('show');
      });

    // 個人：書類送付先が違う
    $(document).on('click', 'input[name="i_address"]', function (e) {
      dispIAdress();
    });

    // 法人：ご契約者住所と違う場合
    $(document).on('click', 'input[name="m_address"]', function (e) {
      dispMAdress();
    });

    // 法人：契約書類送付先
    $(document).on('click', 'input[name="contract_type[]"]', function (e) {
      var v = $(this).val();
      $('input[name="contract_type[]"]').each(function () {
        if ($(this).val() != v) {
          $(this).prop('checked', false);
        }
      });
    });

    // 法人：請求書送付先
    $(document).on('click', 'input[name="invoice_type[]"]', function (e) {
      var v = $(this).val();

      $('input[name="invoice_type[]"]').each(function () {
        if ($(this).val() != v) {
          $(this).prop('checked', false);
        }
      });

      if (v == 'etc') {
        dispInvocieType();
      } else {
        $('.js-invoiceContent').hide();
      }
    });
  });
}
